export const getTargetImage = (self, id) => {
  const grid = self._grids.get(id);
  if (grid == null) {
    throw new Error(`해당 id(${id}) 의 grid 를 찾을 수 없습니다.`);
  }
  const { target_image_el } = grid;
  return target_image_el;
};
